<template>
  <div class="lie-box">
    <el-table ref="multipleTable" class="grayTableTile_02" v-loading="listLoading" :header-cell-class-name="cellClass" :data="sourceList" :height="tableHeight" @selection-change="handleSelectionChange" style="width:100%">
      <el-table-column type="selection" :selectable="checkSelect" width="55" v-if="accessPoint['team:delete'] || accessPoint['team:download']"></el-table-column>

      <el-table-column label="文件名" min-width="230">
        <template slot-scope="scope">
          <!-- fileType：1图片，2视频，3文件夹，0其他  -->
          <!-- <svg-icon class="icon" icon-class="img-shape" v-if="scope.row.fileType == 1" @click="handleImageViewer(scope.row)" /> 
                    <svg-icon class="icon" icon-class="video-shape" v-if="scope.row.fileType == 2" @click="handleImageViewer(scope.row)" />
                    <svg-icon class="icon" icon-class="floder-blue" v-if="scope.row.fileType == 3" @click="handleOptenFolder(scope.row)" />
                    <svg-icon class="icon" icon-class="rests-shape" v-if="scope.row.fileType == 0" @click="handleImageViewer(scope.row)" /> -->

          <svg-icon class="icon" icon-class="floder-blue" v-if="scope.row.fileType == 3" @click="handleOptenFolder(scope.row)" />
          <div class="img-box" @click="handleImageViewer(scope.row)" v-else>
            <svg-icon class="icon-video" icon-class="play-shape" v-if="scope.row.fileType == 2" />
            <el-image class="img-style" :src="scope.row.thumbnailImageUrl">
              <div slot="error" class="el-image__error image-slot">
                <i class="el-icon-picture-outline"></i>
                <span style="line-height:30px">缺少资源</span>
              </div>
            </el-image>
          </div>
          <template v-if="!scope.row.edit">
            <span v-if="scope.row.fileType == 3" style="cursor: pointer;" @click="handleOptenFolder(scope.row)">{{scope.row.fileName}}</span>
            <span v-else style="cursor: pointer;" @click="handleImageViewer(scope.row)">{{scope.row.fileName}}</span>
          </template>

          <div class="input-box" v-else>
            <el-input v-if="scope.row.fileType == 3" size="mini" v-model="scope.row.fileName" style="width:80%"></el-input>

            <el-input v-else size="mini" v-model="scope.row.prefixName" style="width:80%"></el-input>

            <div class="icon-input" @click="handleSaveName(scope.row)">
              <i class="el-icon-check"></i>
            </div>

            <div class="icon-input" @click="handleCancel(scope.row)">
              <i class="el-icon-close"></i>
            </div>
          </div>

        </template>
      </el-table-column>

      <el-table-column label="创建人" min-width="60">
        <template slot-scope="scope">{{scope.row.designerName? scope.row.designerName: scope.row.createUserName}}</template>
      </el-table-column>

      <el-table-column label="修改时间" min-width="100">
        <template slot-scope="scope">{{ scope.row.modifyTime }}</template>
      </el-table-column>

      <el-table-column label="文件大小" min-width="60">

        <template slot-scope="scope">
          <span>{{scope.row | handleFileSize}}</span>
        </template>

      </el-table-column>

      <!-- add:商务添加同步网盘图标写死 -->
      <el-table-column label="同步网盘" min-width="60" v-if="$store.getters.currentRoute.meta.id == 1397">
        <template slot-scope="scope">
          <!-- 待同步 -->
          <!-- <svg-icon class="icon" icon-class="explain" style='width:20px;cursor: unset;' v-if="scope.row.syncStatus == 1"/> -->
          <el-tooltip class="item" effect="dark" content="同步中" placement="bottom" :visible-arrow="false" popper-class="tooltip" v-if="scope.row.syncStatus == 1">
            <svg-icon class="icon" icon-class="explain" style='width:20px;cursor: unset;' />
          </el-tooltip>
          <!-- 同步失败 -->
          <el-tooltip class="item" effect="dark" content="同步失败" placement="bottom" :visible-arrow="false" popper-class="tooltip" v-else-if="scope.row.syncStatus == 3">
            <svg-icon class="icon" icon-class="error" style='width:20px;cursor: unset;' />
          </el-tooltip>
          <!-- 同步成功 -->
          <el-tooltip class="item" effect="dark" content="同步成功" placement="bottom" :visible-arrow="false" popper-class="tooltip" v-else>
            <svg-icon class="icon" icon-class="success" style='width:20px;cursor: unset;' />
          </el-tooltip>
        </template>

      </el-table-column>

      <el-table-column width="180">
        <template slot-scope="scope">
          <!-- add:商务下文件夹不允许重命名  && !($store.getters.currentRoute.meta.id == 1397 && scope.row.fileType == 3)-->
          <el-tooltip class="item" effect="dark" content="重命名" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="scope.row.edit = true" v-if="accessPoint['team:update']">
            <svg-icon class="icon-butn" icon-class="edit_shape" />
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="删除" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="handleDeleteFolder(scope.row)" v-if="accessPoint['team:delete']">
            <svg-icon class="icon-butn" icon-class="delete_shape" />
          </el-tooltip>

          <!-- <el-tooltip class="item" effect="dark" content="推送" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="handlePushFolder(scope.row)"
            v-if="scope.row.fileType !== 3 && accessPoint['ads:push']">
            <svg-icon class="icon-butn" icon-class="push_shape" />
          </el-tooltip> -->

          <!-- <el-tooltip class="item" effect="dark" placement="bottom" :visible-arrow="false" popper-class="tooltip" v-if="scope.row.fileType != 3 && scope.row.outFile==false && synchro==2">
            <div slot="content">同步外网</div>
            <svg-icon class="icon-butn" icon-class="synchro" @click="handleSynchro(scope.row)" />
          </el-tooltip>

          <el-tooltip class="item" effect="dark" placement="bottom" :visible-arrow="false" popper-class="tooltip" v-show="scope.row.fileType != 3 && scope.row.inOutStatus==1 && synchro==2">
            <div slot="content">同步外网中,强制重新执行</div>
            <span class="icon-butn"><i class="el-icon-loading" @click="handleSynchroAgain(item)" style="font-size:16px;"></i></span>
          </el-tooltip> -->

          <el-tooltip class="item" effect="dark" content="下载" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="handleDownloadFolder(scope.row)" v-if="scope.row.fileType !== 3 && accessPoint['team:download']">
            <svg-icon class="icon-butn" icon-class="download_shape" />
          </el-tooltip>
          <!-- synchro==2 && scope.row.outFile && -->
          <!-- <el-tooltip class="item" effect="dark" content="下载" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="handleDownloadFolder(scope.row)"
            v-if="scope.row.fileType !== 3 && accessPoint['team:download']">
            <svg-icon class="icon-butn" icon-class="download_shape" />
          </el-tooltip> -->
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import { syncFileInToOut_ajax } from '@File~/api/file'

export default {
  props: {
    // 数据源列表
    sourceList: {
      type: Array,
      default: () => []
    },

    listLoading: {
      type: Boolean,
      default: true
    },

    barHeight: {
      type: String,
      default: 0
    }
  },

  data() {
    return {
      synchro: 1,
      accessPoint: this.$store.getters.accessPoint, //权限点
      tableHeight: '200px'
    }
  },

  created() {
    this.synchro = this.$store.getters.synchro
  },
  filters: {
    handleFileSize(value) {
      // if (value.fileType === 3) {
      //   return '-'
      // } else {
      if (value.fileSize / 1024 / 1024 / 1024 > 1024) {
        return (value.fileSize / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
      } else if (value.fileSize / 1024 / 1024 > 1024) {
        return (value.fileSize / 1024 / 1024 / 1024).toFixed(2) + 'G'
      } else if (value.fileSize / 1024 > 1024) {
        return (value.fileSize / 1024 / 1024).toFixed(2) + 'MB'
      } else {
        return (value.fileSize / 1024).toFixed(2) + 'KB'
      }

      // }
    },

  },

  methods: {
    init() {
      this.tableHeight = `calc(100vh - 50px - 48px - 96px - ${this.barHeight})`
      // console.log('初始化表格高：', this.tableHeight)
    },

    // 表格选择
    handleSelectionChange(rows) {
      // console.log('表格选中===',rows)
      this.$emit('selectionTable', rows)
    },

    // 保存文件名修改
    handleSaveName(item) {
      // console.log('保存===',item)
      this.$emit('saveFilename', item)
    },

    // 取消文件名修改
    handleCancel(item) {
      console.log('取消===', item)
      this.$emit('cancelFilename', item)
    },

    // 删除文件
    handleDeleteFolder(item) {
      this.$emit('deleteFolder', item)
    },

    // 下载文件
    handleDownloadFolder(item) {
      // if (item.outFile == false && this.synchro == 2) {
      //   this.$message.warning("请先将文件同步至外网")
      //   return false
      // }
      this.$emit('downloadFolder', item)
    },

    // 推送文件
    handlePushFolder(item) {
      this.$emit('pushFolder', item)
    },

    // 同步文件
    handleSynchro(item) {
      // console.log(item,inOut)
      // console.log('同步文件====')
      this.$confirm('确定要将素材同步到外网吗？', '同步外网', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.synchro_ajax(item)
      }).catch(() => {

      });
    },

    synchro_ajax(item) {
      item.inOutStatus = 1
      const data = {
        "fileId": item.id,
        "userId": this.$store.getters.userId,
        "repeat": 0,//是否强制重新执行 默认：0:不强制重新执行 1:强制重新执行
      }
      // 同步接口
      syncFileInToOut_ajax(data).then(response => {
        if (response.code == 1) {
          if (response.data.inOutStatus != 2) {
            setTimeout(() => {
              this.synchro_ajax(item)
            }, 500);
          } else {
            item.inOutStatus = 2
            this.$message.success(item.fileName + ' 同步完成');
            item.thumbnailImageUrl = response.data.thumbnailImageUrl + "&v=1.1"
          }

        }
      })
    },
    handleSynchroAgain(item) {
      // console.log('同步文件====')
      this.$confirm('强制重新将素材同步到外网吗？', '同步外网', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        item.inOutStatus = 1
        const data = {
          "fileId": item.id,
          "userId": this.$store.getters.userId,
          "repeat": 1,//是否强制重新执行 默认：0:不强制重新执行 1:强制重新执行
        }
        // 同步接口
        syncFileInToOut_ajax(data).then(response => {
          if (response.code == 1) {
            if (response.data.inOutStatus != 2) {
              setTimeout(() => {
                this.synchro_ajax(item)
              }, 500);
            } else {
              item.inOutStatus = 2
              this.$message.success(item.fileName + ' 同步完成');
              item.thumbnailImageUrl = response.data.thumbnailImageUrl + "&v=1.1"
            }

          }
        })

      }).catch(() => {

      });
    },

    // 大图预览
    handleImageViewer(item) {
      // if (item.outFile == false && this.synchro == 2) {
      //   this.$message.warning("请先将文件同步至外网")
      //   return false
      // }
      this.$emit('imageViewer', item)
    },

    // 打开文件夹
    handleOptenFolder(item) {
      this.$emit('openFolder', item)
    },

    // 文件夹禁止选折
    checkSelect(row) {
      let isChecked = true;
      if (row.fileType == 3) {
        isChecked = false
      } else {
        isChecked = true
      }
      return isChecked
    },

    // 是否有表头
    cellClass(row) {
      const list = this.filterList()
      if (row.columnIndex === 0 && list.length == 0) {
        return 'DisableSelection'
      }
    },

    // 除了文件夹外的所有文件
    filterList(val) {
      const list = []
      this.sourceList.forEach(item => {
        if (item.fileType != 3) {
          list.push(item)
          if (val == true) {
            item.checked = true
          } else if (val == false) {
            item.checked = false
          }
        }
      })

      return list
    },


  }
}
</script>

<style lang="scss" scoped>
::v-deep .grayTableTile_02 {
  color: #666666;
  thead th {
    background: #f7f7f7;
    color: #999;
    font-weight: 600;
    font-size: 14px;
    padding: 1px 0;
    height: 41px;
    line-height: 41px;
    overflow: hidden;
  }
  thead .el-table-column--selection > .cell {
    padding-left: 14px;
    padding-right: 14px;
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    &::after {
      left: 5px;
      top: 2px;
    }
  }
  .el-table--medium th,
  .el-table--medium td {
    padding: 9px 0;
  }
  .icon-butn {
    cursor: pointer;
    width: 16px;
    height: 16px;
    color: #666666;
    vertical-align: middle;
    margin: 0 6px;
    &:hover {
      color: #3a89ff;
    }
  }
  .icon {
    font-size: 24px;
    width: 24px;
    height: 24px;
    vertical-align: middle;
    color: #3a89ff;
    margin-right: 8px;
    cursor: pointer;
  }
  .img-box {
    position: relative;
    width: 40px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
  }
  .img-style {
    width: 40px;
    height: 30px;
    overflow: hidden;

    margin-right: 5px;
    cursor: pointer;
  }
  .icon-video {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 7;
    margin: -9px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    cursor: pointer;
  }

  .input-box {
    display: inline-flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;

    .icon-input {
      width: 24px;
      height: 24px;
      background: rgba(58, 137, 255, 0.1);
      border-radius: 3px;
      margin-left: 4px;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        font-size: 16px;
        font-weight: 600;
        color: #3a89ff;
      }
    }
  }
}

::v-deep .el-input__inner {
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
  border: 1px solid #3a89ff;
  padding: 0 8px;
}
</style>
<style lang="scss">
.tooltip {
  font-size: 12px;
  padding: 3px 6px;
  background: #000000;
  border-radius: 2px;
  opacity: 0.5;
}

.DisableSelection .cell {
  opacity: 0;
  display: none;
}
.grayTableTile_02 .el-checkbox.is-disabled {
  opacity: 0;
}
</style>